import { createAsyncThunk } from '@reduxjs/toolkit';

import { authSet } from '../../../utils/request';
import { METHOD_POST } from '../../../constants/api';

const postEasyShipShipment = createAsyncThunk('easyShipShipment/postEasyShipShipment',
  async (formData, { rejectWithValue }) => {
    try {
      const data = await authSet(METHOD_POST, '/shipping/easyship', formData);
      return {
        ...data?.shipment,
        errors: data?.errors,
      };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default postEasyShipShipment;
